import { Add, Delete, GpsFixed } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Collapse,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
} from "@mui/material";
import React, { useState } from "react";
import { Fragment } from "react";
import AddEvent from "../AddEvent";

function SelectedPlantItems({
  plants,
  selectedPlant,
  handlePlantClick,
  handleDeletePlant,
  handleGpsPlant,
  handleEventClick,
}) {
  if (!plants || !plants.length) return;

  let numPlants = plants.length;
  let plantElements = [];
  for (let i = 0; i < numPlants; i++) {
    let plant = plants[i];
    let plantHasGps = plant.x !== undefined && plant.y !== undefined;
    let isSelected = selectedPlant === plant;
    plantElements.push(
      <ListItem
        key={i}
        style={{
          cursor: "pointer",
          backgroundColor: isSelected ? "#e0e0e0" : "white",
        }}
        secondaryAction={
          <Stack direction={"row"} spacing={1}>
            {!plantHasGps && (
              <IconButton
                onClick={() => handleGpsPlant(plant)}
                edge="end"
                aria-label="gps"
              >
                <GpsFixed />
              </IconButton>
            )}

            <IconButton
              onClick={() => handleEventClick(plant)}
              edge="end"
              aria-label="comments"
            >
              <Add />
            </IconButton>
            <IconButton
              onClick={() => handleDeletePlant(plant)}
              edge="end"
              aria-label="comments"
            >
              <Delete />
            </IconButton>
          </Stack>
        }
      >
        <ListItemText
          onClick={() => handlePlantClick(plant)}
          primary={plant.name}
        />
      </ListItem>
    );
  }

  return (
    <List component="div" disablePadding>
      {plantElements}
    </List>
  );
}

export default function PlantListItem({
  plant,
  selectedPlant,
  onPlantClick,
  onAddPlant,
  handleDeletePlant,
  handleGpsPlant,
  siteUid,
}) {
  const [showAddEvent, setShowAddEvent] = useState(false);
  // check if plant is object or array
  // if object, then plant is a single plant
  // if array, then plant is a list of plants
  let isMultiplePlants = plant instanceof Array;
  let name = isMultiplePlants ? plant[0].name : plant.name;
  let quantity = isMultiplePlants ? plant.length : plant.quantity;
  let plantImage = isMultiplePlants ? plant[0].image : plant.image;
  let plants = isMultiplePlants ? plant : [plant];
  plant = isMultiplePlants ? plant[0] : plant;

  let isSelected = selectedPlant && name == selectedPlant.name;

  return (
    <Fragment>
      {showAddEvent && (
        <AddEvent
          open={showAddEvent}
          onClose={() => setShowAddEvent(false)}
          item={plant}
          onAddEvent={() => setShowAddEvent(false)}
          siteUid={siteUid}
          itemType="plant"
        />
      )}
      <ListItem
        key={name}
        style={{
          cursor: "pointer",
          backgroundColor: isSelected ? "#e0e0e0" : "white",
        }}
        secondaryAction={
          <IconButton
            onClick={() => onAddPlant(plant)}
            edge="end"
            aria-label="comments"
          >
            <Add />
          </IconButton>
        }
      >
        <ListItemAvatar onClick={() => onPlantClick(plant)}>
          <Avatar src={plantImage} alt={name} />
        </ListItemAvatar>
        <ListItemText
          onClick={() => onPlantClick(plant)}
          primary={name}
          secondary={`Quantity: ${quantity}`}
        />
      </ListItem>
      <Collapse in={isSelected} timeout="auto" unmountOnExit>
        <SelectedPlantItems
          plants={plants}
          selectedPlant={selectedPlant}
          handlePlantClick={onPlantClick}
          handleDeletePlant={handleDeletePlant}
          handleGpsPlant={handleGpsPlant}
          handleEventClick={() => setShowAddEvent(true)}
        />
      </Collapse>
    </Fragment>
  );
}
